import { render } from "./ProjectView.vue?vue&type=template&id=52380ae9&scoped=true"
import script from "./ProjectView.vue?vue&type=script&lang=js"
export * from "./ProjectView.vue?vue&type=script&lang=js"

import "./ProjectView.vue?vue&type=style&index=0&id=52380ae9&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52380ae9"]])

export default __exports__